var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-ug",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M124.02 0h496.06v496.06H124.02z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(-128) scale(1.0321)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#ffe700",
    d: "M0 330.73h744.09v82.665H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 248.03h744.09v82.665H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#de3908",
    d: "M0 165.37h744.09v82.665H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#ffe700",
    d: "M0 82.701h744.09v82.665H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 0h744.09v82.665H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.276 248.03c0 42.653-34.577 77.23-77.23 77.23s-77.23-34.577-77.23-77.23 34.577-77.23 77.23-77.23 77.23 34.577 77.23 77.23z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.895,
    fill: "#fffdff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.42 188.825l-5.014-9.235c1.935-1.935 5.19-3.43 10.38-3.43 0 .352-.529 10.115-.529 10.115l-4.837 2.55z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.895,
    fill: "#de3108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.255 186.368l.704-10.203s10.38-.616 16.008 6.156c.088-.088-5.54 7.916-5.54 7.916l-11.172-3.87z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.895,
    fill: "#ffe700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.605 190.148l5.101-7.915c3.43 3.606 4.837 6.157 5.365 10.027.088.088-8.092 2.023-8.092 1.935s-2.286-3.959-2.374-4.047z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.895,
    fill: "#de3108"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M360.972 320.847s9.587-10.994 28.234-8.619c-2.815-4.574-11.874-4.046-11.874-4.046s-2.814-21.373-.616-22.429 11.522.088 11.522.088c1.231 0 3.343-3.342 1.672-5.453-1.672-2.111-6.597-10.203-4.574-11.787 2.023-1.582 13.017.88 13.017.88l-31.048-39.756s-3.166-14.952 3.166-22.164c7.653-6.333 6.861-13.194 6.597-13.106-1.056-6.948-11.61-11.962-18.734-5.54-4.222 5.1-1.408 8.97-1.408 8.97s-11.082 2.99-11.522 4.926c-.44 1.935 12.49-.352 12.49-.352l-1.232 8.884S331.507 234.21 350.77 254c.176-.088.616-.88.616-.88s6.773 8.357 13.897 10.203c6.684 6.861 6.07 5.805 6.07 5.805s1.318 10.82.087 12.93c-1.671-.528-18.734-1.143-21.286-.176-2.286.704-11.082.264-8.883 14.6 1.67-3.87 3.166-7.3 3.166-7.3s-.264 5.19 1.848 7.037c-.352-5.454 2.023-9.147 2.023-9.147s.44 5.98 1.758 6.86c1.32.88 1.32-9.675 8.62-8.796 7.3.88 12.578.616 12.578.616s2.463 20.67 1.671 22.605c-5.278-1.232-17.855.528-18.647 3.694 7.388-.44 10.82.44 10.82.44s-5.982 5.277-4.135 8.355z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.839
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M363.934 208.066s-18.304 20.175-10.407 35.613c.42-2.153.237-3.505.5-3.417-.44-.264 2.27 1.857 2.064 1.444.058-1.116-.825-3.508-.825-3.508l2.477.62-1.446-2.684 3.51.413s-1.239-3.303-.826-3.303c.412 0 2.89.207 2.89.207-5.206-9.342-.296-17.1 2.063-25.385z",
    fillRule: "evenodd",
    stroke: "#9ca69c",
    strokeLinecap: "round",
    strokeWidth: 0.839,
    fill: "#9ca69c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.293 190.76s.968 6.948-2.814 8.97c-.616.44-2.99 1.233-2.639 2.64.44 1.935 1.495 1.583 2.99 1.231 3.958-.704 8.532-9.147 2.463-12.841z",
    fillRule: "evenodd",
    stroke: "#9ca69c",
    strokeWidth: 0.895,
    fill: "#9ca69c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.524 196.743a1.495 1.495 0 1 1-2.99 0 1.495 1.495 0 0 1 2.99 0z",
    fillRule: "evenodd",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.628 202.545c-.968.792-6.07 6.07-1.056 8.005 5.19-1.408 3.782-2.375 4.926-3.519.03-2.374-2.58-2.99-3.87-4.486z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.895,
    fill: "#de3108"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M368.709 252.422c-.264 1.144-1.407 5.365.175 8.62 4.399-1.847 6.421-1.32 7.917-.352-3.606-2.903-5.013-4.134-8.092-8.268z",
    fillRule: "evenodd",
    stroke: "#9ca69c",
    strokeLinecap: "round",
    strokeWidth: 0.839,
    fill: "#9ca69c"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M376.277 272.388l.264 9.85s3.43.617 5.013 0c1.584-.615-.088-6.86-5.277-9.85z",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.839,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.165 273.617s-6.333-15.305-22.517-19.175-14.073-21.109-12.753-22.165c.704-1.495 1.231-3.782 5.893-1.582 4.662 2.198 26.123 13.016 29.201 13.544s.44 29.73.176 29.378z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.895,
    fill: "#9ca69c"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M385.773 254.356c-.264.176 21.637 12.93 15.04 23.924 6.246-4.134 4.222-11.346 4.222-11.346s5.101 13.281-7.3 19.79c1.32 1.144 2.2.88 2.2.88l-2.112 2.11s-.968 1.583 7.388-2.463c-2.287 1.848-2.462 3.167-2.462 3.167s.615 1.76 6.068-2.99c-4.398 4.75-5.365 7.212-5.365 7.124 11.874-1.056 37.733-39.668-8.18-51.103 2.463 2.552 2.11 2.2 2.11 2.2l-11.61 8.707z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.839,
    fill: "#de3108"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M386.74 250.575c2.99 2.111 4.045 2.815 4.397 3.87-2.726-.615-5.189-.44-5.189-.44s-5.893-5.628-6.948-6.068c-.792 0-5.366-2.903-5.366-2.903-2.286-1.143-4.397-9.059 4.047-6.772 8.706 4.133 9.938 4.486 9.938 4.486l10.379 3.254 5.98 6.685s-10.641-5.278-11.96-5.366c2.902 2.375 4.573 5.63 4.573 5.63-3.372-.969-6.303-1.848-9.851-2.376z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.839,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.318 203.338s10.203-2.463 11.434-2.11",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.839,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#de3908",
    d: "M0 413.4h744.09v82.665H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUg);
export default __webpack_public_path__ + "static/media/ug.5f94cebe25dcdc50b47c90ada74d75c9.svg";
export { ForwardRef as ReactComponent };